import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { postUser } from "../api";

export const useCreateUser = () => {
  const router = useNavigate();
  const queryClient = useQueryClient();
  const { mutate, isPending } = useMutation({
    mutationFn: postUser,
    onSuccess() {
      queryClient.refetchQueries({ queryKey: ["USER"] });
      router("/user");
      toast.success("Success Create User");
    },
  });

  return { create: mutate, isPending };
};
